// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"ee6955b7","185":"6de2fef6","235":"6de2fef6","587":"31159805","711":"6de2fef6","948":"6de2fef6"}[chunkId] + ".chunk.css";
};